import React, { useState, useEffect, Dispatch, SetStateAction } from 'react';
import { Modal, Form, Select, Input } from 'antd';
import { getSegmentFeedDropDownData, makeKeyInLowerCaseHelper } from '../../utils';
import { SeriesDropdownValue } from '../scheduler/types';
import { fetchWithAuthorization } from '../../utils/session_utils';


export const getSeriesSelectDataFromSegments = async (
	setSeriesSelectData: Dispatch<SetStateAction<any[]>>,
	setSeriesMap: Dispatch<SetStateAction<any>>,
	setIsSeriesValuesLoaded: Dispatch<SetStateAction<boolean>>,
	setIsLoading?: (value: boolean) => void
) => {
	setIsLoading && setIsLoading(true);
	fetchWithAuthorization(`${process.env.REACT_APP_BACK_END_API}/snowflake/segment-series-options`)
		.then(res => res.json())
		.then(async ({ data }) => {
			const convertedObject = await makeKeyInLowerCaseHelper(data);
			const seriesMap: any = {};
			convertedObject.forEach((series: any) => {
				seriesMap[series.id] = series.titles;
			});
			setSeriesMap(seriesMap);
			setSeriesSelectData(convertedObject);
			setIsSeriesValuesLoaded(true);
			setIsLoading && setIsLoading(false);
		})
		.catch(() => setIsLoading && setIsLoading(false));
};

interface FilterSegmentsModalProps {
  visible: boolean;
  onClose: () => void
  onOk: () => void;
  form: any;
}

const FilterSegmentsModal: React.FC<FilterSegmentsModalProps> = ({
  visible,
  onClose,
  onOk,
  form,
}) => {
  const [seriesDropdownValues, setSeriesDropdownValues] = useState<SeriesDropdownValue[]>([]);
  const [seriesMap, setSeriesMap] = useState({});
  const [isSeriesValuesLoaded, setIsSeriesValuesLoaded] = React.useState(false);
  const [segmentParentFeedDropDownValues, setSegmentParentFeedDropDownValues] = useState<any[]>([]);
  const [isParentFeedValuesLoaded, setIsParentFeedValuesLoaded] = useState(false);

  useEffect(() => {
    if (!isParentFeedValuesLoaded) {
      getSegmentFeedDropDownData(setSegmentParentFeedDropDownValues, setIsParentFeedValuesLoaded); 
    }
  }, [isParentFeedValuesLoaded]);



  useEffect(() => {
    if (!isSeriesValuesLoaded) {
      getSeriesSelectDataFromSegments(setSeriesDropdownValues, setSeriesMap, setIsSeriesValuesLoaded); 
    }
  }, [isSeriesValuesLoaded]);


  return (
    <Modal
      title="Filter Segments"
      open={visible}
      onCancel={onClose}
      onOk={onOk}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Series"
          name="seriesId"
          rules={[{ required: false, message: 'Please select a series!' }]}
        >
          <Select
            showSearch
            optionFilterProp="label"
            placeholder="Select item"
            loading={seriesDropdownValues.length === 0}
            style={{ width: "100%" }}
            dropdownStyle={{ maxWidth: "100%" }}
            options={seriesDropdownValues.map((item) => ({
              value: item.id,
              label: item.titles,
            }))}
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            allowClear // This enables the clear option
            />
        </Form.Item>
        <Form.Item
          label="Segment Feed"
          name="segmentFeed"
          rules={[{ required: false, message: 'Please select segment feed!' }]}
        >
          <Select
            optionFilterProp="label"
            placeholder="Select item"
            loading={segmentParentFeedDropDownValues.length === 0}
            style={{ width: "100%" }}
            dropdownStyle={{ maxWidth: "100%" }}
            options={segmentParentFeedDropDownValues.map((item) => ({
              value: item.feed_id,
              label: item.feed_name,
            }))}
            allowClear // This enables the clear option
          />
        </Form.Item>
        <Form.Item
          label="Segment Type"
          name="segmentType"
          rules={[{ required: false, message: 'Please select segment type!' }]}
        >
          <Select
            optionFilterProp="label"
            placeholder="Select item"
            style={{ width: "100%" }}
            dropdownStyle={{ maxWidth: "100%" }}
            options={[
              { value: 'ad', label: 'Ad' },
              { value: 'media', label: 'Media' },
              { value: 'episode', label: 'Episode' },
              { value: 'cue_segment', label: 'Cue Segment'}
            ]}
            />
        </Form.Item>
        <Form.Item
          label="Search"
          name="searchString"
          rules={[{ required: false, message: 'Please enter search term!' }]}
        >
          <Input
            placeholder="Enter search term"
            style={{ width: "100%" }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default FilterSegmentsModal;